// src/js/reducers/index.js
import * as types from "../constants/action-types";


export default function siteLogReducer(state = {}, action) {
  
    switch (action.type) {

        case types.LOGOUT:
            return []
        case types.CREATE_SITELOG_SUCCESS:
        console.log(action.sitelog)
            return action.sitelog;

        case types.UPDATE_SITELOG_SUCCESS:
        console.log(action.sitelog)
            return action.sitelog;

        case types.LOAD_SITELOG_SUCCESS:
        console.log(action.sitelog)
            return action.sitelog;

        case types.REMOVE_SITELOG_SUCCESS:
            return action.item;

        default:
            return state;
    };
};
